module.exports = __webpack_public_path__ + "static/media/particles-3.fd853303.svg";